/*global
    aap
*/
aap.checkField = function (field) {

    'use strict';

    var fieldValue = field.value,
        $this = $(field),
        $error = $this.next(),
        $great = $this.siblings('.great'),
        passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/,
        phoneRegex = /^\d{10}$/;

    //check if empty
    if (aap.is(fieldValue).empty()) {

        var canBeEmpty = $this.data('empty');

        if(!canBeEmpty) {
            aap.validationErrors.push('All fields are required');
            $this.removeClass('valid').addClass('error');
            $great.text('Oops!').removeClass('valid-flag').addClass('error-flag');

            if (field.id === 'emailAddress') {
                $error.text('Required');
            }

            return;
        }
    }

    //check email validity
    if (field.id === 'email' && !aap.is(fieldValue).valid('email')) {

        aap.validationErrors.push('Email Address is not valid');
        $this.removeClass('valid').addClass('error');
        $great.text('Oops!').removeClass('valid-flag').addClass('error-flag');
        return;
    }

    if (field.id === 'suggestions_email' && !aap.is(fieldValue).valid('email')) {
        aap.validationErrors.push('Email Address is not valid');
        $this.removeClass('valid').addClass('error');
        return;
    }

    if (field.id === 'emailAddress' && !aap.is(fieldValue).valid('email')) {
        $error.text('Not valid');
        $this.removeClass('valid').addClass('error');
        return;
    }

    //check password
    if (field.id === 'password' && !aap.is(fieldValue).valid('regex', passwordRegex)) {
        aap.validationErrors.push('Password should be at least 8 characters with 1 Number and 1 Capital Letter');
        $this.removeClass('valid').addClass('error');
        $great.text('Oops!').removeClass('valid-flag').addClass('error-flag');
        return;
    }

    //check phone
    if (field.id === 'phone' && !aap.is(fieldValue).valid('regex', phoneRegex)) {
        aap.validationErrors.push('Phone Number should be 10 digits with no dashes');
        $this.removeClass('valid').addClass('error');
        $great.text('Oops!').removeClass('valid-flag').addClass('error-flag');
        return;
    }

    //check email_confirmed same as email
    if (field.id === 'email_confirmation') {
        if (field.value !== document.getElementById('email').value) {
            aap.validationErrors.push('Confirm Email should be same as Email');
            $this.removeClass('valid').addClass('error');
            $great.text('Oops!').removeClass('valid-flag').addClass('error-flag');
            return;
        }

        if (!aap.is(fieldValue).valid('email')) {
            aap.validationErrors.push('Email Address confirmation is not valid');
            $this.removeClass('valid').addClass('error');
            $great.text('Oops!').removeClass('valid-flag').addClass('error-flag');
            return;
        }
    }

    //check password_confirmed same as password
    if (field.id === 'password_confirmation' && field.value !== document.getElementById('password').value) {
        aap.validationErrors.push('Confirm Password should be same as Password');
        $this.removeClass('valid').addClass('error');
        $great.text('Oops!').removeClass('valid-flag').addClass('error-flag');
        return;
    }

    //check breed
    if (field.id === 'dummy_breed' || field.id === 'dummy_second_breed') {
        var breed = field.value;
        var dontCheck = $this.data('empty') && fieldValue === '';
        var exists = $.grep(aap.breeds, function(e){ return e.label === breed; });

        if(!dontCheck && exists.length === 0) {
            aap.validationErrors.push('Please Select a Breed from List');
            $this.removeClass('valid').addClass('error');
            return;
        }
    }

    // everything looks fine remove error classes
    if(field.id === 'email_confirmation' || field.id === 'password_confirmation') {
        $great.text('Great!').addClass('valid-flag');
    }
    $great.removeClass('error-flag');
    $this.removeClass('error');
    $this.addClass('valid');

};
